// Freelancers · Mailadressen (28 sep, besluiten Joris) — losse ingang achter het recht
// `freelancer_mail`, zodat PL's en management freelancer-mailadressen kunnen aanmaken, pauzeren
// en hervatten zonder Admin Instellingen. Rendert hetzelfde component als de admin-sectie;
// Beëindigen blijft daarin alleen zichtbaar met admin_settings edit. Later een tab in HR & leveranciers.
import React from 'react';
import { Box } from '@mui/material';
import PageHeader from '../ui-components/PageHeader';
import FreelancerMail from '../components/FreelancerMail/FreelancerMail';

export default function FreelancerMailadressenPage() {
  return (
    <Box sx={{ width: '100%', maxWidth: 1400, mx: 'auto', px: { xs: 2, md: 3 }, py: 3 }}>
      <PageHeader
        icon="alternate_email"
        title="Freelancers · Mailadressen"
        subtitle="Een eigen Full Frame-mailadres per freelancer: aanmaken, pauzeren als de licentie naar een ander moet (mail blijft bewaard) en hervatten."
      />
      <FreelancerMail />
    </Box>
  );
}
